import React from 'react';
import { useStickyLayout } from '../hooks/useStickyLayout';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../../../redux/canvasResolutionSlice';
import { visualizationMode } from '../../../../redux/visualizationModeSlice';
import _ from 'lodash';

type StickyLayoutWrapperProps = { children: React.ReactNode };

const StickyLayoutWrapper = ({ children }: StickyLayoutWrapperProps) => {
	const ref: any = React.useRef(null);
	const { blockClass, isStuck, setIsStuck, componentId } = useStickyLayout();

	const VMMode = useSelector(visualizationMode);
	const selectedResolution = useSelector(selectedToggleValue);

	React.useEffect(() => {
		const iframe = document.querySelector('iframe')?.contentDocument;
		const container = iframe?.getElementsByClassName('canvas-iframe')[0];

		if (VMMode && container && ref?.current) {
			const scrollEvt = () => {
				if (container.scrollTop > ref.current.clientHeight + ref.current.offsetTop) {
					setIsStuck(true);
				} else {
					setIsStuck(false);
				}
			};
			const throttle = _.throttle(scrollEvt, 250);
			container.addEventListener('scroll', throttle);
			return () => container.removeEventListener('scroll', throttle);
		}
	}, [VMMode, selectedResolution, ref]);

	return (
		<div
			data-selection={componentId}
			ref={ref}
			style={{ height: isStuck ? '100px' : 'auto' }}
			className={`vtex-sticky-layout-0-x-wrapper
      vtex-sticky-layout-0-x-wrapper--${blockClass} wrapper wrapper--${blockClass}`}
		>
			{children}
		</div>
	);
};

export default StickyLayoutWrapper;
